/* eslint-disable import/prefer-default-export */

import React, { useState, useEffect, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, ButtonGroup } from '@material-ui/core';
import Loading from '../../components/loading/Loading';
import SelectOption from './SelectOption';
import api from '../../service/axios/api';
import Individuotable from './Individuotable';
import LogsSerproTable from './LogsSerproTable';
import LegalEntitytable from './Legalentity';
import FlashContext from '../../components/contexts/FlashContext';
import SelectOptionLog from './SelectOptionLog';


export function Individuo() {
  const { notifyError } = useContext(FlashContext)
  const [pageType, setPageType] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [selected, setSelected] = useState([]);
  const [chipData, setChipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('Buscando arquivos...');

  // LOGS SERPRO
  const [dataLog, setDataLog] = useState([]);
  const [pageLog, setPageLog] = useState(0);
  const [totalLog, setTotalLog] = useState(0);
  const [itensLog, setItensLog] = useState(10);
  const [chipDataLog, setChipDataLog] = useState([]);

  // Pessoa Jurídica
  const [dataJur, setDataJur] = useState([]);
  const [pageJur, setPageJur] = useState(0);
  const [totalJur, setTotalJur] = useState(0);
  const [itensJur, setItensJur] = useState(10);


  useEffect(() => {
    searchData()
    searchLegalIdentity()

  }, []);

  const searchLegalIdentity = () => {
    setLoading(true);
    setMsg('Buscando pessoa jurídica...');
    api.legalEntities.getAllLegalIdentity(itensJur, pageJur + 1)
      .then(res => {
        setDataJur(res.docs)
        setTotalJur(res.total)
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  }
  const searchData = extra => {
    setLoading(true);
    setMsg('Buscando indivíduos...');
    api.commercialAgent.getSummaryIndividuos(page + 1, itens, extra, chipData)
      .then(res => {
        setData(res.data.docs);
        setTotal(res.data.total);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const searchDataLog = extra => {
    setLoading(true);
    setMsg('Buscando logs...');
    api.commercialAgent.getSummaryLogsSerpro(pageLog + 1, itensLog, extra, chipDataLog)
      .then(res => {
        setDataLog(res.data.docs);
        setTotalLog(res.data.total);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  useEffect(() => {
    searchDataLog();
  }, [pageLog, itensLog]);

  useEffect(() => {
    searchLegalIdentity();
  }, [pageJur, itensJur]);

  const templateDownload = () => {
    setMsg('Gerando planilha....');
    setLoading(true);
    api.commercialAgent
      .getSummaryIndividuosXls(chipData)
      .then(res => {
        const url = res.retorno.fileLink;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'individuos.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        if (err?.response?.data) {
          if (err.response.data.Problems) {
            err.response.data.Problems.forEach((e) => {
              notifyError(e.Message);
            });
          } else {
            notifyError(err.response.data.Message);
          }
        } else if (err.message) {
          if (err.message === "Network Error") {
            notifyError(
              "Erro de conexão, verifique sua conexão com a internet e tente novamente"
            );
          } else {
            notifyError(err.message);
          }
        }
      })
      .finally(() => setLoading(false));
  };


  const templateDownloadLegalIdentity = () => {
    setMsg('Gerando planilha....');
    setLoading(true);
    api.legalEntities
      .getXlsLegalIdentity()
      .then(res => {
        const url = res.retorno.fileLink;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'individuos.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        if (err?.response?.data) {
          if (err.response.data.Problems) {
            err.response.data.Problems.forEach((e) => {
              notifyError(e.Message);
            });
          } else {
            notifyError(err.response.data.Message);
          }
        } else if (err.message) {
          if (err.message === "Network Error") {
            notifyError(
              "Erro de conexão, verifique sua conexão com a internet e tente novamente"
            );
          } else {
            notifyError(err.message);
          }
        }
      })
      .finally(() => setLoading(false));
  };



  const templateDownloadLog = () => {
    setMsg('Gerando planilha de logs....');
    setLoading(true);
    api.commercialAgent
      .getSummaryLogsSerproXls(chipDataLog)
      .then(res => {
        const url = res.retorno.fileLink;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'logs_serpro.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        if (err?.response?.data) {
          if (err.response.data.Problems) {
            err.response.data.Problems.forEach((e) => {
              notifyError(e.Message);
            });
          } else {
            notifyError(err.response.data.Message);
          }
        } else if (err.message) {
          if (err.message === "Network Error") {
            notifyError(
              "Erro de conexão, verifique sua conexão com a internet e tente novamente"
            );
          } else {
            notifyError(err.message);
          }
        }
      })
      .finally(() => setLoading(false));
  };


  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        style={{ display: 'flex', justifyContent: 'start' }}
      >
        {/* <h3 style={{ marginTop: "20px" }}>Indivíduos</h3> */}
        <Grid item xs={12}>
          <ButtonGroup color="primary">
            <Button
              onClick={() => setPageType(0)}
              variant={pageType === 0 ? 'contained' : 'outlined'}
            >
              Indivíduos
            </Button>
            <Button
              onClick={() => setPageType(2)}
              variant={pageType === 2 ? 'contained' : 'outlined'}
            >
              Pessoa jurídica
            </Button>
            <Button
              onClick={() => setPageType(1)}
              variant={pageType === 1 ? 'contained' : 'outlined'}
            >
              Logs Serpro
            </Button>

          </ButtonGroup>
        </Grid>
      </Grid>
      <Loading open={loading} msg={msg} />
      <Grid style={{ width: "100%", justifyContent: "end" }}>
        {pageType === 0 && <SelectOption
          setStatus={() => console.log('')}
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
        />}

        {pageType === 1 && <SelectOptionLog
          setStatus={() => console.log('')}
          setChipData={setChipDataLog}
          chipData={chipDataLog}
          find={searchDataLog}
        />}



      </Grid>
      {pageType === 0 && <Individuotable
        docs={data}
        setDocs={setData}
        page={page}
        setPage={setPage}
        itens={itens}
        setItens={setItens}
        total={total}
        setSelected={setSelected}
        selected={selected}
        searchData={searchData}
        templateDownload={templateDownload}
      />}

      {pageType === 1 && <LogsSerproTable
        docs={dataLog}
        setDocs={setDataLog}
        page={pageLog}
        setPage={setPageLog}
        itens={itensLog}
        setItens={setItensLog}
        total={totalLog}
        setSelected={setSelected}
        selected={selected}
        searchData={searchDataLog}
        templateDownload={templateDownloadLog}
      />}
      {pageType === 2 && <LegalEntitytable
        docs={dataJur}
        setDocs={setDataJur}
        page={pageJur}
        setPage={setPageJur}
        itens={itensJur}
        setItens={setItensJur}
        total={totalJur}
        setSelected={setSelected}
        selected={selected}
        searchData={searchLegalIdentity}
        templateDownload={templateDownloadLegalIdentity}
      />}
    </>
  );
}
